var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass(),on:{"click":_vm.handleClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('p',{staticClass:"sub"},[_vm._v("Ik wil een")]),_c('p',{staticClass:"main"},[_vm._v("volledig herstel")]),_c('p',{staticClass:"sub"},[_vm._v("doorgeven.")])])
}]

export { render, staticRenderFns }